import { createSelector } from "@reduxjs/toolkit";
import { helpers } from "../../../packages/helpers";
import { selectChatMessages } from "./select-chat-messages";
import { selectChatSettings } from "./select-chat-settings";

const { getStringValue } = helpers.text;

export const selectLastReadMessageId = createSelector(
  selectChatMessages,
  selectChatSettings,
  (messages, { lastReadMessageIndex }) =>
    getStringValue(messages[lastReadMessageIndex]?.id)
);
